<div #masterFormContainer id="treatment-plan-container" class="treatment-container"
  data-cy="treatment-plan-approval-main-container">
  @if (!isLoading && treatment) {
    <div data-cy="treatment-plan-approval-content-container">
      <h2 class="treatment-title" data-cy="treatment-plan-approval-treatment-description">Treatment Option: {{treatment.Description}}</h2>
      @if (treatment) {
        <div #tableContainer data-cy="treatment-plan-approval-table-container">
          <!-- Desktop Table View -->
          <div class="desktop-view">
            <div class="table-top"
              data-cy="treatment-plan-approval-table-header-container">
              <div class="tp-column tp-header"
              data-cy="treatment-plan-approval-tooth-column-header">Tooth</div>
              <div class="tp-column tp-header"
              data-cy="treatment-plan-approval-phase-column-header">Phase</div>
              <div class="tp-column tp-header"
              data-cy="treatment-plan-approval-procedure-column-header">Procedure</div>
              <div class="tp-column tp-header"
              data-cy="treatment-plan-approval-fee-column-header">Fee</div>
              <div class="tp-column tp-header"
                data-cy="treatment-plan-approval-deductible-column-header">
              Deductible</div>
              <div class="tp-column tp-header"
                data-cy="treatment-plan-approval-insurance-column-header">Insurance
              </div>
              <div class="tp-column tp-header"
              data-cy="treatment-plan-approval-due-est-column-header">Due Est.</div>
            </div>
            @if (treatment && treatment.Procedures) {
              <div class="treatment-list" data-cy="treatment-plan-approval-procedure-list">
                @for (model of treatment.Procedures; track model; let i = $index) {
                  <div
                    [ngClass]="{'procedure-row-even': i % 2 === 0, 'procedure-row-odd': i % 2 !== 0}"
                    data-cy="treatment-plan-approval-procedure-item-{{i}}">
                    <div class="procedure-row"
                      data-cy="treatment-plan-approval-procedure-item-content-{{i}}">
                      <div class="tp-column"
                        data-cy="treatment-plan-approval-procedure-tooth-column-{{i}}">
                        <span
                        data-cy="treatment-plan-approval-procedure-tooth-description-{{i}}">{{model.tooth?.cfgToothDescriptions[0]?.Notation}}</span>
                      </div>
                      <div class="tp-column"
                        data-cy="treatment-plan-approval-procedure-phase-column-{{i}}">
                        <span data-cy="treatment-plan-approval-procedure-order-{{i}}">{{model.ItemOrder}}</span>
                      </div>
                      <div class="tp-column autocomplete"
                        data-cy="treatment-plan-approval-procedure-details-column-{{i}}">
                        <div class="procedure-details"
                          data-cy="treatment-plan-approval-procedure-code-name-container-{{i}}">
                          <span data-cy="treatment-plan-approval-procedure-code-{{i}}">{{model.Code}}</span>
                          <div class="procedure-name"
                            data-cy="treatment-plan-approval-procedure-name-container-{{i}}">
                            <span data-cy="treatment-plan-approval-procedure-name-{{i}}">{{escapeHtml(model.Description)}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="tp-column"
                        data-cy="treatment-plan-approval-procedure-fee-column-{{i}}">
                        <div class="procedure-fee"
                          data-cy="treatment-plan-approval-procedure-adjusted-fee-{{i}}">
                        ${{getFee(model)}}</div>
                      </div>
                      <div class="tp-column"
                        data-cy="treatment-plan-approval-procedure-deductible-column-{{i}}">
                        <div class="procedure-fee" data-cy="treatment-plan-approval-procedure-deductible-{{i}}">
                        ${{getDeductible(model)}}</div>
                      </div>
                      <div class="tp-column"
                        data-cy="treatment-plan-approval-procedure-insurance-column-{{i}}">
                        <div class="procedure-fee"
                          data-cy="treatment-plan-approval-procedure-insurance-estimate-{{i}}">
                        ${{getInsuranceEstimate(model)}}</div>
                      </div>
                      <div class="tp-column"
                        data-cy="treatment-plan-approval-procedure-due-est-column-{{i}}">
                        <div class="procedure-fee"
                          data-cy="treatment-plan-approval-procedure-payment-estimate-{{i}}">
                        ${{getPaymentEstimate(model)}}</div>
                      </div>
                    </div>
                  </div>
                }
                <div class="table-bottom"
                  data-cy="treatment-plan-approval-table-footer-container">
                  <div class="total-row"
                    data-cy="treatment-plan-approval-total-row-container">
                    <div class="tp-column total-label"
                      data-cy="treatment-plan-approval-total-label-container">
                      <span data-cy="treatment-plan-approval-total-label">TOTAL</span>
                    </div>
                    <div class="tp-column"
                      data-cy="treatment-plan-approval-total-fee-column">
                      <div class="procedure-fee"
                        data-cy="treatment-plan-approval-procedure-total-adjusted-fee">
                      ${{getTotalFee()}}</div>
                    </div>
                    <div class="tp-column"
                      data-cy="treatment-plan-approval-total-deductible-column">
                      <div class="procedure-fee" data-cy="treatment-plan-approval-procedure-total-deductible">
                      ${{getTotalDeductible()}}</div>
                    </div>
                    <div class="tp-column"
                      data-cy="treatment-plan-approval-total-insurance-column">
                      <div class="procedure-fee"
                        data-cy="treatment-plan-approval-procedure-total-insurance-estimate">
                      ${{getTotalInsuranceEstimate()}}</div>
                    </div>
                    <div class="tp-column"
                      data-cy="treatment-plan-approval-total-due-est-column">
                      <div class="procedure-fee"
                        data-cy="treatment-plan-approval-procedure-total-payment-estimate">
                      ${{getTotalPaymentEstimate()}}</div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
          <!-- Mobile Card View -->
          <div class="mobile-view">
            @if (treatment && treatment.Procedures) {
              <div class="mobile-procedure-list" data-cy="treatment-plan-approval-procedure-list-mobile">
                @for (model of treatment.Procedures; track model; let i = $index) {
                  <div
                    class="mobile-procedure-card"
                    data-cy="treatment-plan-approval-procedure-item-mobile-{{i}}">
                    <div class="mobile-card-header">
                      <div class="mobile-card-title">
                        <span class="mobile-tooth" data-cy="treatment-plan-approval-procedure-tooth-mobile-{{i}}">
                          Tooth: {{model.tooth?.cfgToothDescriptions[0]?.Notation || 'N/A'}}
                        </span>
                        <span class="mobile-phase" data-cy="treatment-plan-approval-procedure-phase-mobile-{{i}}">
                          Phase: {{model.ItemOrder}}
                        </span>
                      </div>
                    </div>
                    <div class="mobile-card-body">
                      <div class="mobile-procedure-info">
                        <span class="mobile-code" data-cy="treatment-plan-approval-procedure-code-mobile-{{i}}">
                          {{model.Code}}
                        </span>
                        <span class="mobile-name" data-cy="treatment-plan-approval-procedure-name-mobile-{{i}}">
                          {{model.ProcedureName}}
                        </span>
                      </div>
                      <div class="mobile-financial-grid">
                        <div class="mobile-financial-item">
                          <span class="mobile-label">Fee</span>
                          <span class="mobile-value" data-cy="treatment-plan-approval-procedure-fee-mobile-{{i}}">
                            ${{getFee(model)}}
                          </span>
                        </div>
                        <div class="mobile-financial-item">
                          <span class="mobile-label">Deductible</span>
                          <span class="mobile-value" data-cy="treatment-plan-approval-procedure-deductible-mobile-{{i}}">
                            ${{getDeductible(model)}}
                          </span>
                        </div>
                        <div class="mobile-financial-item">
                          <span class="mobile-label">Insurance</span>
                          <span class="mobile-value" data-cy="treatment-plan-approval-procedure-insurance-mobile-{{i}}">
                            ${{getInsuranceEstimate(model)}}
                          </span>
                        </div>
                        <div class="mobile-financial-item">
                          <span class="mobile-label">Due Est.</span>
                          <span class="mobile-value" data-cy="treatment-plan-approval-procedure-due-mobile-{{i}}">
                            ${{getPaymentEstimate(model)}}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                <div class="mobile-total-card" data-cy="treatment-plan-approval-total-mobile">
                  <div class="mobile-total-header">
                    <span data-cy="treatment-plan-approval-total-label-mobile">TOTAL</span>
                  </div>
                  <div class="mobile-financial-grid">
                    <div class="mobile-financial-item">
                      <span class="mobile-label">Fee</span>
                      <span class="mobile-value" data-cy="treatment-plan-approval-total-fee-mobile">
                        ${{getTotalFee()}}
                      </span>
                    </div>
                    <div class="mobile-financial-item">
                      <span class="mobile-label">Deductible</span>
                      <span class="mobile-value" data-cy="treatment-plan-approval-total-deductible-mobile">
                        ${{getTotalDeductible()}}
                      </span>
                    </div>
                    <div class="mobile-financial-item">
                      <span class="mobile-label">Insurance</span>
                      <span class="mobile-value" data-cy="treatment-plan-approval-total-insurance-mobile">
                        ${{getTotalInsuranceEstimate()}}
                      </span>
                    </div>
                    <div class="mobile-financial-item">
                      <span class="mobile-label">Due Est.</span>
                      <span class="mobile-value" data-cy="treatment-plan-approval-total-due-mobile">
                        ${{getTotalPaymentEstimate()}}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
          <div class="treatment-signature" data-cy="treatment-plan-approval-signature-section">
            <div #padContainer class="signature-pad-container"
              data-cy="treatment-plan-approval-signature-pad-container" [style]="'width: ' + signaturePadOptions.canvasWidth + 'px; height: ' + signaturePadOptions.canvasHeight + 'px;'">
              <!-- @if (treatment.enumTreatmentPlanStatusID.toLowerCase()==='00000a32-1000-0000-0000-000000000002') { -->
                <!-- <signature-pad
                  class="signature-pad"
                  #signaturePad
                  [options]="signaturePadOptions"
                  (onBeginEvent)="onSignatureDrawStart()"
                  (onEndEvent)="onSignatureDrawComplete()"
                  data-cy="treatment-plan-approval-signature-pad">
                </signature-pad> -->
                <canvas #signatureContainer [hidden]="!isApprovalRequired" data-cy="treatment-planning-signature-pad-input" [width]="signaturePadOptions.canvasWidth" [height]="signaturePadOptions.canvasHeight"></canvas>
              <!-- } -->
              <img alt="signature" [hidden]="isApprovalRequired || !signatureBase64" class="signature-image" [src]="signatureBase64" data-cy="treatment-plan-approval-signature-image" />

            </div>
            @if (treatment?.enumTreatmentPlanStatusID?.toLowerCase()==='00000a32-1000-0000-0000-000000000002') {
              <div class="signature-spacer"></div>
              <div class="signature-actions"
                data-cy="treatment-plan-approval-signature-actions-container">
                <button class="tdo-button tdo-save" (click)="ApproveTreatment()" [disabled]="!isSigned"
                data-cy="treatment-plan-approval-approve-button">Approve</button>
                <button class="tdo-button tdo-save signature-reject-button" (click)="RejectTreatment()"
                data-cy="treatment-plan-approval-reject-button">Reject</button>
                <button mat-button class="tdo-button primary-accent signature-reset-button"
                  (click)="resetSignature()"
                data-cy="treatment-plan-approval-reset-signature-button">Reset signature</button>
              </div>
              <div class="signature-spacer"></div>
            }
          </div>
        </div>
      }
    </div>
  }
  @if (isLoading && treatmentPlanId) {
    <div class="spinner-container"
      data-cy="treatment-plan-approval-loading-spinner-container">
      <mat-spinner data-cy="treatment-plan-approval-spinner"></mat-spinner>
    </div>
  }
</div>